import { render, staticRenderFns } from "./MonksHeader.vue?vue&type=template&id=2b1d4ff1"
import script from "./MonksHeader.vue?vue&type=script&lang=js"
export * from "./MonksHeader.vue?vue&type=script&lang=js"
import style0 from "./MonksHeader.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports